import { render, staticRenderFns } from "./VentaCompraCartera.vue?vue&type=template&id=346d8f3c&"
import script from "./VentaCompraCartera.vue?vue&type=script&lang=js&"
export * from "./VentaCompraCartera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports